// extracted by mini-css-extract-plugin
export default {"textCountSelected":"text-count-selected_textCountSelected__3nlc3"};